
import { Star } from 'lucide-react';
import { PlaceHolderImages } from '../lib/placeholder-images';
import React from 'react';

interface TestimonialCardProps {
  testimonial: {
    id: string;
    quote: string;
    name: string;
    location: string;
  };
}

export function TestimonialCard({ testimonial }: TestimonialCardProps) {
  const image = PlaceHolderImages.find(p => p.id === `testimonial-${testimonial.id}`);

  return (
    <div className="text-center relative z-10">
      {image && (
          <img
            src={image.imageUrl}
            alt={image.description}
            width={100}
            height={100}
            className="rounded-full object-cover mx-auto mb-6"
            data-ai-hint={image.imageHint}
          />
        )}
      <div className="flex items-center justify-center mb-4">
            {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 text-primary fill-current" />
            ))}
        </div>
      <p className="text-2xl md:text-3xl font-medium max-w-2xl mx-auto">&quot;{testimonial.quote}&quot;</p>
      <p className="font-semibold text-lg mt-6">{testimonial.name}</p>
      <p className="text-sm text-gray-500">{testimonial.location}</p>
    </div>
  );
}
